<!-- <ng-container *ngIf="isLoading">
    <div class="overlay">
        <div class="loaderScreen">
            <img src="../../../assets/loaderLogo.svg" width="150px" alt="">
        </div>
    </div>
</ng-container> -->

<ng-container *ngIf="isLoading">
  <div class="overlay">
      <!-- <div class="loaderScreen">
          <img src="../../../assets/loaderLogo.svg" width="150px" alt="">
      </div>-->
      <body> 
  
        <div class="loader_body">
          <span class="loader"></span>
          <img src="../../../assets/adv.png" alt="loader_image">
        </div>
        
      </body>
  </div>
</ng-container>



